import config from 'config';

import { FC } from 'react';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectResult } from 'store/player/playerSelectors';
import { selectQuiz } from 'store/quiz/quizSelectors';
import IQuiz from 'models/Quiz';
import MediaFormats from 'types/MediaFormats';
//
import { QRCodeCanvas } from "qrcode.react";

import classes from './styles.module.css';

const QrCode:FC = () => {
  const result:any = useAppSelector(selectResult);
  const storeQuiz = useAppSelector(selectQuiz);
  const quiz:IQuiz | null = storeQuiz || result?.quiz || null;

  const qrCodeLink = quiz?.publicLeaderboard.quizQRCodeLink || `${config.quizURL}/quiz/${quiz?.quizNameSlug}`;
  const isRectLogoFormat = quiz?.publicLeaderboard.quizQrCodeLogoFormat === MediaFormats.RectLogo;

  if (!quiz?.publicLeaderboard.quizQRCodeEnabled) return null;
  return (
    <div className="">
      <div className="w-1/2 sm:w-full p-3 sm:p-8 rounded-3xl mb-8 portrait:max-w-[600px] portrait:mx-auto shadow-primary-border">
        <div className={`${classes.qrWrapper} flex flex-col p-2 rounded-xl w-full h-full`}>
          <QRCodeCanvas
            value={qrCodeLink}
            level="H"
            size={868}
            imageSettings={{
              src: quiz.publicLeaderboard.quizQRCodeLogo || '',
              width: isRectLogoFormat ? 300 : 200,
              height: isRectLogoFormat ? 150 : 200,
              excavate: true
            }}
          />
        </div>
      </div>
      <div className="relative">
        <h2
          className={`relative pr-3 italic uppercase font-extrabold text-center z-10 ${classes.qrTitle}`}
          style={{
            background: `linear-gradient(90deg, ${quiz.publicLeaderboard.primaryColor}, ${quiz.publicLeaderboard.secondaryColor})`,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          {quiz?.publicLeaderboard.quizQRCodeTitle}
        </h2>
      </div>
    </div>
  )
}

export default QrCode;